import * as React from 'react'

import { Box, Table } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { observer } from 'mobx-react'

import type Store from 'modules/attendance/components/ClockIn/Store'

import Checkbox from './Checkbox'
import styles from './index.module.css'

interface Props {
  date: moment.Moment
  store: Store
  disabled: boolean
  submitHalfDayShift: (shift: TimesheetPageShiftFragment) => void
  shifts: TimesheetPageShiftFragment[]
}

const FormColumn = ({ disabled, submitHalfDayShift, shifts }: Props) => {
  const cx = classNames.bind(styles)

  const submitShift = (shift: TimesheetPageShiftFragment) => {
    if (disabled) return

    submitHalfDayShift(shift)
  }

  return (
    <Table.Cell>
      {shifts.map((shift) => (
        <Box
          onClick={() => submitShift(shift)}
          className={cx('wrapper', {
            disabled,
          })}
          key={shift.date + shift.halfDay}
        >
          <Box
            className={cx('checkboxWrapper', {
              disabled,
            })}
          >
            <Checkbox shift={shift} disabled={disabled} />
          </Box>
        </Box>
      ))}
    </Table.Cell>
  )
}

export default observer(FormColumn)
